import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DATABASE_MODES } from '../api';

function DatabaseModeToggle({ value, onChange }) {
  const selected = value === DATABASE_MODES.DEMO ? DATABASE_MODES.DEMO : DATABASE_MODES.LIVE;
  const [showLiveConfirm, setShowLiveConfirm] = useState(false);

  const buttonStyle = (isSelected, side) => ({
    padding: '0.35rem 0.75rem',
    border: '1px solid rgba(0,0,0,0.15)',
    borderRadius: side === 'left' ? '0.25rem 0 0 0.25rem' : '0 0.25rem 0.25rem 0',
    borderLeft: side === 'right' ? 'none' : '1px solid rgba(0,0,0,0.15)',
    backgroundColor: isSelected ? 'var(--jd-primary)' : 'transparent',
    color: 'var(--jd-primary-dark)',
    fontSize: '0.875rem',
    fontWeight: isSelected ? 600 : 400,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  });

  const requestLive = () => {
    if (selected === DATABASE_MODES.LIVE) return;
    setShowLiveConfirm(true);
  };

  const confirmLive = () => {
    setShowLiveConfirm(false);
    onChange(DATABASE_MODES.LIVE);
  };

  return (
    <>
      <div className="d-flex align-items-center" role="group" aria-label="Database">
        <button
          type="button"
          onClick={() => onChange(DATABASE_MODES.DEMO)}
          style={buttonStyle(selected === DATABASE_MODES.DEMO, 'left')}
          aria-pressed={selected === DATABASE_MODES.DEMO}
        >
          Demo
        </button>
        <button
          type="button"
          onClick={requestLive}
          style={buttonStyle(selected === DATABASE_MODES.LIVE, 'right')}
          aria-pressed={selected === DATABASE_MODES.LIVE}
        >
          Live
        </button>
      </div>

      <Modal show={showLiveConfirm} onHide={() => setShowLiveConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Switch to Live?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Live uses real clinic data, including protected health information. Confirm you are
          in a private, HIPAA-safe setting before continuing. Patient names will be blurred;
          you can reveal them with the eye icon.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLiveConfirm(false)}>
            Back
          </Button>
          <Button variant="primary" onClick={confirmLive}>
            Continue to Live
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DatabaseModeToggle;
